export default class QuantitySelector extends HTMLElement {

    constructor() {
        super();
        this.input = null;
        this.btnMinus = null;
        this.btnPlus = null;
    }

    connectedCallback() {
        this.input = this.querySelector('input[type="number"]');
        
        if (!this.input) return;
        
        // Create minus button
        this.btnMinus = document.createElement('button');
        this.btnMinus.type = 'button';
        this.btnMinus.className = 'btn btn-sm btn-white';
        this.btnMinus.innerHTML = '<i class="m-icon m-icon-minus"></i>';
        this.btnMinus.addEventListener('click', () => this.decrement());
        
        // Create plus button
        this.btnPlus = document.createElement('button');
        this.btnPlus.type = 'button';
        this.btnPlus.className = 'btn btn-sm btn-white';
        this.btnPlus.innerHTML = '<i class="m-icon m-icon-add"></i>';
        this.btnPlus.addEventListener('click', () => this.increment());
        
        // Insert buttons
        this.insertBefore(this.btnMinus, this.input);
        this.appendChild(this.btnPlus);
        
        // Initialize state
        this.updateMinusButton();
        
        // Listen to input changes
        this.input.addEventListener('input', () => this.updateMinusButton());
        this.input.addEventListener('change', () => this.updateMinusButton());
    }

    getValue() {
        return parseInt(this.input.value) || 0;
    }

    setValue(value) {
        const min = parseInt(this.input.getAttribute('min')) || 0;
        const newValue = Math.max(min, value);
        this.input.value = newValue;
        this.updateMinusButton();
    }

    increment() {
        const step = parseInt(this.input.getAttribute('step')) || 1;
        this.setValue(this.getValue() + step);
    }

    decrement() {
        const step = parseInt(this.input.getAttribute('step')) || 1;
        this.setValue(this.getValue() - step);
    }

    updateMinusButton() {
        const min = parseInt(this.input.getAttribute('min')) || 0;
        const currentValue = this.getValue();
        
        if (currentValue <= min) {
            this.btnMinus.disabled = true;
        } else {
            this.btnMinus.disabled = false;
        }
    }

}
